var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getPartnerLogo())?_c('img',{staticClass:"thumbnail__partner-logo",attrs:{"srcset":((_vm.getPartnerLogo().x1) + " 1x, " + (_vm.getPartnerLogo().x2) + " 2x"),"src":_vm.getPartnerLogo().x1,"alt":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }